import React from "react";
const FiltersContext = React.createContext();
export default FiltersContext;